import Vue from 'vue'
import VueGtm from '@gtm-support/vue2-gtm'

export default router => {
  Vue.use(VueGtm, {
    id: 'GTM-WW3S3QB',
//    debug: true,
    vueRouter: router,
  })
}
